import { array, intersect, literal, partial, string, struct, union } from 'io-ts/Decoder';

import { DatasetKey } from './DatasetKey';

/**
 * The Usage Reports request is intentionally tiny: pick a dataset and an
 * optional sort. There are no filters (admin dashboard, per spec). `sort.field`
 * is a free-form string because columns are dynamic per dataset (the MV's own
 * columns), validated at the query layer against the resolved column set.
 */
export const Request = intersect(
	struct({
		datasetKey: DatasetKey,
	})
)(
	partial({
		sort: array(
			struct({
				field: string,
				direction: union(literal('asc'), literal('desc')),
			})
		),
	})
);
